import { useEffect, useRef, useState } from "react";

export const useDebouncedAction = (
  action: () => void,
  dependencies: any[],
  delay = 400
) => {
  const [isDebouncing, setIsDebouncing] = useState(false);
  const isFirstRender = useRef(true);
  const savedAction = useRef(action);

  useEffect(() => {
    savedAction.current = action;
  }, [action]);

  useEffect(() => {
    if (isFirstRender.current) {
      isFirstRender.current = false;
      savedAction.current();
      return;
    }

    setIsDebouncing(true);
    let innerTimeout: number | undefined;

    const handler = window.setTimeout(() => {
      savedAction.current();
      innerTimeout = window.setTimeout(() => setIsDebouncing(false), 50);
    }, delay);

    return () => {
      window.clearTimeout(handler);
      if (innerTimeout !== undefined) window.clearTimeout(innerTimeout);
    };
  }, dependencies);

  return isDebouncing;
};
